import FormCheck from "./FormCheck";
const Switch = (props) => (<FormCheck {...props} type="switch"/>);
export default Object.assign(Switch, {
    Input: FormCheck.Input,
    Label: FormCheck.Label,
});
